// extracted by mini-css-extract-plugin
module.exports = {"banner":"y2CXO","banner-info":"_1xxCq","banner-info-content":"+YYVA"};